import React from 'react';
import { Link } from 'react-router-dom';
import './Legalpages.css';

const AboutUs = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>About FocusView.ai</h1>
        <p className="legal-last-updated">Your AI-Powered News Hub</p>

        <section className="legal-section">
          <h2>Our Mission</h2>
          <p>
            FocusView.ai is dedicated to delivering curated, AI-enhanced news coverage across three critical
            domains: cryptocurrency, artificial intelligence, and politics. We believe in making complex news
            accessible, understandable, and actionable for everyone.
          </p>
          <p>
            In an era of information overload, we cut through the noise to bring you what matters most. Our
            AI-powered platform aggregates news from trusted sources, provides intelligent summaries, and
            highlights breaking developments so you stay informed without getting overwhelmed.
          </p>
        </section>

        <section className="legal-section">
          <h2>What We Do</h2>
          <p>FocusView.ai combines cutting-edge technology with journalistic principles to provide:</p>
          <ul>
            <li><strong>Comprehensive News Aggregation:</strong> We collect articles from 18+ leading news
            sources including CNN, Fox News, CoinDesk, TechCrunch, Politico, NPR, and more</li>
            <li><strong>AI-Powered Summaries:</strong> Advanced AI technology generates concise, accurate
            summaries so you can quickly grasp key points</li>
            <li><strong>Sentiment Analysis:</strong> Understand the tone and implications of news stories
            with our AI-driven sentiment detection</li>
            <li><strong>Breaking News Alerts:</strong> Stay ahead of the curve with real-time notifications
            of significant developments</li>
            <li><strong>Trending Topics:</strong> Discover what's capturing attention across the crypto, AI,
            and political landscapes</li>
            <li><strong>Smart Search:</strong> Find exactly what you need with our intelligent full-text
            search capabilities</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Why These Topics?</h2>
          <p>
            <strong>Cryptocurrency:</strong> The digital currency revolution is reshaping finance and economics.
            From Bitcoin's price movements to regulatory developments, we keep you updated on the crypto ecosystem.
          </p>
          <p>
            <strong>Artificial Intelligence:</strong> AI is transforming every industry and aspect of modern life.
            We track breakthroughs, ethical debates, and the companies leading the AI revolution.
          </p>
          <p>
            <strong>Politics:</strong> Political decisions impact markets, technology policy, and societal progress.
            We cover elections, legislation, and policy debates that shape our world.
          </p>
        </section>

        <section className="legal-section">
          <h2>Our Technology</h2>
          <p>
            FocusView.ai is built on a modern, scalable architecture designed for speed, reliability, and
            intelligent content delivery:
          </p>
          <ul>
            <li><strong>Cloud Infrastructure:</strong> Powered by Amazon Web Services for global accessibility
            and reliability</li>
            <li><strong>AI Integration:</strong> Leveraging advanced language models for content analysis and
            summarization</li>
            <li><strong>Real-Time Processing:</strong> Continuous monitoring and updating of news sources</li>
            <li><strong>Responsive Design:</strong> Seamless experience across desktop, tablet, and mobile devices</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Our Commitment</h2>
          <p>
            <strong>Accuracy:</strong> We aggregate from reputable sources and provide clear attribution to
            original publishers.
          </p>
          <p>
            <strong>Transparency:</strong> Our AI-generated content is clearly labeled, and we always link to
            original sources.
          </p>
          <p>
            <strong>Privacy:</strong> Your data is protected with industry-standard security measures. We never
            sell your personal information.
          </p>
          <p>
            <strong>Innovation:</strong> We continuously improve our platform with new features and enhanced
            AI capabilities.
          </p>
        </section>

        <section className="legal-section">
          <h2>Community Rewards</h2>
          <p>
            We value our early adopters! The first 100 subscribers who provide a Dogecoin wallet address will
            receive 5 DOGE per article read as a thank you for being part of our community.
          </p>
        </section>

        <section className="legal-section">
          <h2>Contact Us</h2>
          <p>
            We'd love to hear from you! Whether you have questions, feedback, or partnership inquiries, reach
            out to us:
          </p>
          <p>
            Email: admin@focusview.ai<br />
            Website: <a href="https://www.focusview.ai">https://www.focusview.ai</a>
          </p>
        </section>

        <div className="legal-navigation">
          <Link to="/contact" className="legal-link">Contact Us</Link>
          <Link to="/" className="legal-link">Back to Home</Link>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;